module.exports = __webpack_public_path__ + "img/magento-services-integration.923d20bf.webp";